import * as React from "react";
import { SVGProps } from "react";

const SvgTwoClubs = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 288 402"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M276.1.2H11.4S.3.5.3 15.2v371.7c0 14.7 11.1 15 11.1 15H276s11.1-.3 11.1-15V15.2c.1-14.7-11-15-11-15Z"
      fill="#fff"
    />
    <mask
      id="two-clubs_svg__b"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={217}
      width={288}
      height={185}
    >
      <path
        d="M169.4 217c-56.4 0-112.8 0-169.2.1v169.8c0 14.7 11.1 15 11.1 15H276s11.1-.3 11.1-15V217H169.4Z"
        fill="url(#two-clubs_svg__a)"
      />
    </mask>
    <g mask="url(#two-clubs_svg__b)">
      <path
        d="M169.4 217c-56.4 0-112.8 0-169.2.1v169.8c0 14.7 11.1 15 11.1 15H276s11.1-.3 11.1-15V217H169.4Z"
        fill="url(#two-clubs_svg__c)"
      />
    </g>
    <mask
      id="two-clubs_svg__e"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={288}
      height={201}
    >
      <path
        d="M.3 200.6c24.1 0 48.3 0 72.4.1 69.6 0 139.2 0 208.7.1h5.7V15.2C287.1.5 276 .2 276 .2H11.4S.3.5.3 15.2v185.4Z"
        fill="url(#two-clubs_svg__d)"
      />
    </mask>
    <g mask="url(#two-clubs_svg__e)">
      <path
        d="M.3 200.6c24.1 0 48.3 0 72.4.1 69.6 0 139.2 0 208.7.1h5.7V15.2C287.1.5 276 .2 276 .2H11.4S.3.5.3 15.2v185.4Z"
        fill="url(#two-clubs_svg__f)"
      />
    </g>
    <mask
      id="two-clubs_svg__h"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={5}
      y={0}
      width={282}
      height={402}
    >
      <path
        d="M286.6 15.2v371c0 14.7-11.1 15-11.1 15h-265s-2.4-.1-5-1.6c2.9 2.1 5.8 2.2 5.8 2.2h264.6s11.1-.3 11.1-15V15.2c0-14.7-11.1-15-11.1-15h-.6c.2 0 11.3.3 11.3 15Z"
        fill="url(#two-clubs_svg__g)"
      />
    </mask>
    <g mask="url(#two-clubs_svg__h)">
      <path
        d="M286.6 15.2v371c0 14.7-11.1 15-11.1 15h-265s-2.4-.1-5-1.6c2.9 2.1 5.8 2.2 5.8 2.2h264.6s11.1-.3 11.1-15V15.2c0-14.7-11.1-15-11.1-15h-.6c.2 0 11.3.3 11.3 15Z"
        fill="url(#two-clubs_svg__i)"
      />
    </g>
    <mask
      id="two-clubs_svg__k"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={282}
      height={402}
    >
      <path
        d="M.8 386.9v-371C.8 1.2 11.9.9 11.9.9h265s2.4.1 5 1.6C279 .4 276.1.3 276.1.3H11.4S.3.6.3 15.3V387c0 14.7 11.1 15 11.1 15h.6c-.1-.1-11.2-.4-11.2-15.1Z"
        fill="url(#two-clubs_svg__j)"
      />
    </mask>
    <g mask="url(#two-clubs_svg__k)">
      <path
        d="M.8 386.9v-371C.8 1.2 11.9.9 11.9.9h265s2.4.1 5 1.6C279 .4 276.1.3 276.1.3H11.4S.3.6.3 15.3V387c0 14.7 11.1 15 11.1 15h.6c-.1-.1-11.2-.4-11.2-15.1Z"
        fill="url(#two-clubs_svg__l)"
      />
    </g>
    <mask
      id="two-clubs_svg__n"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={29}
      width={1}
      height={347}
    >
      <path
        d="M.2 29.2v346.3l.6-2.1V35.5l-.6-6.3Z"
        fill="url(#two-clubs_svg__m)"
      />
    </mask>
    <g mask="url(#two-clubs_svg__n)">
      <path
        d="M.2 29.2v346.3l.6-2.1V35.5l-.6-6.3Z"
        fill="url(#two-clubs_svg__o)"
      />
    </g>
    <path
      d="M21 80.1c-.6 7.5-4.8 12.7-4.8 12.7h9.6c0-.1-4.2-5.3-4.8-12.7Z"
      fill="#000"
    />
    <path
      d="M28 71.6c-1 0-1.9.2-2.7.5l-.1-.1c1.7-1.3 2.8-3.3 2.8-5.6 0-3.9-3.1-7-7-7s-7 3.1-7 7c0 2.4 1.2 4.6 3.1 5.8-.9-.5-2-.7-3.1-.7-3.9 0-7 3.1-7 7s3.1 7 7 7c3.8 0 6.8-3 7-6.7.2 3.7 3.2 6.7 7 6.7 3.9 0 7-3.1 7-7 0-3.8-3.1-6.9-7-6.9ZM24.9 48.1c.8 0 1.5-.1 2-.2s.9-.3 1.2-.5c.3-.2.5-.5.7-.9.2-.4.4-1 .7-1.8h2.2l-.4 7.4H10.4V51c.7-1.8 1.7-3.6 2.9-5.5s3-4 5.3-6.6c2-2.2 3.4-3.8 4.2-4.9.9-1.2 1.7-2.3 2.1-3.2a10.024 10.024 0 0 0 1.3-4.9c0-1.3-.2-2.4-.6-3.4-.4-1-1-1.7-1.9-2.3-.8-.6-1.9-.8-3.2-.8-3.2 0-5.3 1.8-6.4 5.3H11v-4.9c2-1 4-1.7 5.7-2.1 1.8-.4 3.4-.6 4.8-.6 3.1 0 5.5.7 7.1 2.1 1.6 1.4 2.4 3.4 2.4 6 0 .9-.1 1.7-.3 2.5-.2.8-.5 1.5-.8 2.2-.4.7-.9 1.5-1.5 2.4-.6.8-1.4 1.7-2.1 2.6-.8.9-2.1 2.3-4 4.4-3.2 3.4-5.6 6.4-7.1 8.9h9.7v-.1ZM263.4 321c.6-7.5 4.8-12.7 4.8-12.7h-9.6s4.2 5.2 4.8 12.7Z"
      fill="#000"
    />
    <path
      d="M256.4 329.5c1 0 1.9-.2 2.7-.5l.1.1c-1.7 1.3-2.8 3.3-2.8 5.6 0 3.9 3.1 7 7 7s7-3.1 7-7c0-2.4-1.2-4.6-3.1-5.8.9.5 2 .7 3.1.7 3.9 0 7-3.1 7-7s-3.1-7-7-7c-3.8 0-6.8 3-7 6.7-.2-3.7-3.2-6.7-7-6.7-3.9 0-7 3.1-7 7 0 3.7 3.2 6.9 7 6.9ZM259.6 352.9c-.8 0-1.5.1-2 .2s-.9.3-1.2.5c-.3.2-.5.5-.7.9-.2.4-.4 1-.7 1.8h-2.2l.4-7.4h20.9v1.2c-.7 1.8-1.7 3.6-2.9 5.5s-3 4-5.3 6.6c-2 2.2-3.4 3.8-4.2 4.9-.9 1.2-1.7 2.3-2.1 3.2a10.024 10.024 0 0 0-1.3 4.9c0 1.3.2 2.4.6 3.4.4 1 1 1.7 1.9 2.3.8.6 1.9.8 3.2.8 3.2 0 5.3-1.8 6.4-5.3h3.1v4.9c-2 1-4 1.7-5.7 2.1-1.8.4-3.4.6-4.8.6-3.1 0-5.5-.7-7.1-2.1-1.6-1.4-2.4-3.4-2.4-6 0-.9.1-1.7.3-2.5.2-.8.5-1.5.8-2.2.4-.7.9-1.5 1.5-2.4.6-.8 1.4-1.7 2.1-2.6.8-.9 2.1-2.3 4-4.4 3.2-3.4 5.6-6.4 7.1-8.9h-9.7ZM142.6 88.4c-1.2 14.8-9.6 25.2-9.6 25.2h19.2s-8.3-10.4-9.6-25.2Z"
      fill="#000"
    />
    <path
      d="M156.5 71.6c-1.9 0-3.7.4-5.4 1.1l-.1-.1c3.3-2.5 5.5-6.6 5.5-11.1 0-7.7-6.2-13.9-13.9-13.9s-13.9 6.2-13.9 13.9c0 4.8 2.5 9.1 6.2 11.6-1.9-.9-4-1.5-6.2-1.5-7.7 0-13.9 6.2-13.9 13.9s6.2 13.9 13.9 13.9c7.5 0 13.6-5.9 13.9-13.3.3 7.4 6.4 13.3 13.9 13.3 7.7 0 13.9-6.2 13.9-13.9 0-7.6-6.2-13.9-13.9-13.9ZM142.6 313.8c1.2-14.8 9.6-25.2 9.6-25.2H133s8.4 10.3 9.6 25.2Z"
      fill="#000"
    />
    <path
      d="M128.7 330.5c1.9 0 3.7-.4 5.4-1.1l.1.1c-3.3 2.5-5.5 6.6-5.5 11.1 0 7.7 6.2 13.9 13.9 13.9s13.9-6.2 13.9-13.9c0-4.8-2.5-9.1-6.2-11.6 1.9.9 4 1.5 6.2 1.5 7.7 0 13.9-6.2 13.9-13.9s-6.2-13.9-13.9-13.9c-7.5 0-13.6 5.9-13.9 13.3-.3-7.4-6.4-13.3-13.9-13.3-7.7 0-13.9 6.2-13.9 13.9s6.2 13.9 13.9 13.9Z"
      fill="#000"
    />
    <defs>
      <radialGradient
        id="two-clubs_svg__a"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(139.265 -136.717) scale(580.826)"
      >
        <stop offset={0.616} />
        <stop offset={0.752} stopColor="#020202" />
        <stop offset={0.804} stopColor="#090909" />
        <stop offset={0.841} stopColor="#151515" />
        <stop offset={0.872} stopColor="#262626" />
        <stop offset={0.899} stopColor="#3C3C3C" />
        <stop offset={0.922} stopColor="#585858" />
        <stop offset={0.944} stopColor="#797979" />
        <stop offset={0.963} stopColor="#9F9F9F" />
        <stop offset={0.982} stopColor="#CBCBCB" />
        <stop offset={0.998} stopColor="#F9F9F9" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="two-clubs_svg__c"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(139.265 -136.717) scale(580.826)"
      >
        <stop offset={0.616} stopColor="#fff" />
        <stop offset={0.788} stopColor="#FDFDFD" />
        <stop offset={0.854} stopColor="#F6F6F6" />
        <stop offset={0.901} stopColor="#EAEAEA" />
        <stop offset={0.94} stopColor="#D9D9D9" />
        <stop offset={0.974} stopColor="#C3C3C3" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="two-clubs_svg__d"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(145.012 370.882) scale(416.198)"
      >
        <stop offset={0.616} />
        <stop offset={0.71} stopColor="#020202" />
        <stop offset={0.762} stopColor="#0A0A0A" />
        <stop offset={0.805} stopColor="#181818" />
        <stop offset={0.842} stopColor="#2C2C2C" />
        <stop offset={0.875} stopColor="#464646" />
        <stop offset={0.906} stopColor="#656565" />
        <stop offset={0.935} stopColor="#8A8A8A" />
        <stop offset={0.963} stopColor="#B6B6B6" />
        <stop offset={0.988} stopColor="#E5E5E5" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="two-clubs_svg__f"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(145.012 370.882) scale(416.198)"
      >
        <stop offset={0.616} stopColor="#fff" />
        <stop offset={0.747} stopColor="#FDFDFD" />
        <stop offset={0.821} stopColor="#F5F5F5" />
        <stop offset={0.88} stopColor="#E7E7E7" />
        <stop offset={0.932} stopColor="#D3D3D3" />
        <stop offset={0.978} stopColor="#BABABA" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="two-clubs_svg__g"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-12.02 .037) scale(462.125)"
      >
        <stop offset={0.099} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="two-clubs_svg__i"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-12.02 .037) scale(462.125)"
      >
        <stop offset={0.099} stopColor="#fff" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="two-clubs_svg__j"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(78.62 117.116) scale(393.607)"
      >
        <stop />
        <stop offset={0.007} stopColor="#090909" />
        <stop offset={0.048} stopColor="#373737" />
        <stop offset={0.093} stopColor="#626262" />
        <stop offset={0.142} stopColor="#888" />
        <stop offset={0.195} stopColor="#A8A8A8" />
        <stop offset={0.254} stopColor="#C4C4C4" />
        <stop offset={0.32} stopColor="#DADADA" />
        <stop offset={0.397} stopColor="#EBEBEB" />
        <stop offset={0.493} stopColor="#F6F6F6" />
        <stop offset={0.627} stopColor="#FDFDFD" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="two-clubs_svg__l"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(78.62 117.116) scale(393.607)"
      >
        <stop stopColor="#fff" />
        <stop offset={0.141} stopColor="#fff" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="two-clubs_svg__m"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(-462.094 0 0 -462.112 299.388 .036)"
      >
        <stop offset={0.099} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="two-clubs_svg__o"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(-462.094 0 0 -462.112 299.388 .036)"
      >
        <stop offset={0.099} stopColor="#fff" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
    </defs>
  </svg>
);

export default SvgTwoClubs;
